import { csx } from '@vtex/admin-ui'

export const styles = {
  detailedView: csx({
    display: 'flex',
    gap: '$space-2',
    flexDirection: 'column',
    alignItems: 'flex-start',
  }),
}
